import { Component, Inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

export interface IEditNoteDialogData {
  note: string;
}

export const NOTE_MAX_LENGTH = 5000;

@Component({
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    TranslatePipe,
    MatDialogClose,
  ],
  selector: 'app-edit-note-dialog',
  styles: [':host mat-form-field { width: 100%; }'],
  template: `
    <h1 mat-dialog-title>{{ 'page.widgetContent.editNoteDialog.title' | translate }}</h1>
    <div mat-dialog-content>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'page.widgetContent.addEditDialog.note' | translate }}</mat-label>
        <textarea
          matInput
          cdkFocusInitial
          rows="6"
          [maxlength]="NOTE_MAX_LENGTH"
          [formControl]="noteControl"
        ></textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close (click)="onCancel()">{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button [disabled]="isInvalid()" (click)="onSave()">{{ 'button.save' | translate }}</button>
    </div>
  `,
})
export class EditNoteDialogComponent {
  public readonly NOTE_MAX_LENGTH = NOTE_MAX_LENGTH;

  public readonly noteControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(NOTE_MAX_LENGTH)],
  });

  public readonly isInvalid = toSignal(this.noteControl.statusChanges.pipe(map(() => this.noteControl.invalid)), {
    initialValue: this.noteControl.invalid,
  });

  constructor(
    private readonly dialogRef: MatDialogRef<EditNoteDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) data: IEditNoteDialogData,
  ) {
    this.noteControl.setValue(data.note ?? '');
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onSave(): void {
    if (this.noteControl.invalid) {
      return;
    }

    this.dialogRef.close(this.noteControl.value);
  }
}
